var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 1700 1200",
    viewBox: "0 0 1700 1200",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F49B33;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 850,
    cy: 600.5,
    r: 521.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1042.1 494c-5.1-65.4-61.2-88.3-132.2-95.8l1.6-90.6-55.1-0.9-1.6 88.2c-14.5-0.3-29.3-0.2-44.1-0.2l1.6-88.8-55.1-1-1.6 90.6c-11.9 0-23.7 0.1-35.1-0.2v-0.3l-76.1-1.3-1 58.9s40.8-0.1 40.1 0.7c22.3 0.4 29.4 13.5 31.3 24.7l-1.8 103.2c1.5 0 3.5 0.1 5.8 0.5l-5.8-0.1-2.5 144.6c-1.1 7-5.4 18.1-21.1 17.9 0.7 0.6-40.1-0.7-40.1-0.7l-12.1 65.6 71.8 1.3c13.3 0.3 26.5 0.7 39.4 1l-1.6 91.6 55.1 0.9 1.6-90.6c15.1 0.5 29.8 0.9 44.1 1.2l-1.6 90.2 55.1 0.9 1.6-91.4c92.8-3.7 158.1-25.9 167.7-112.9 7.7-70-24.7-101.9-77.1-115.4 32.2-15.6 52.7-43.9 48.8-91.8zm-80.6 194.6c-1.1 68.5-118.3 58.6-155.7 58l2.2-121.4c37.4 0.6 154.8-8.1 153.5 63.4zm-22.6-171.8c-1.1 62.3-98.8 53.3-129.9 52.8l1.9-110.1c31.1 0.5 129.1-7.7 128 57.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/BTC.c700ce96330b11452a40054e9b5d65e5.svg";
export { ForwardRef as ReactComponent };